import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const GradeCalculatorPage = () => {
  const [grades, setGrades] = useState([{ score: '', weight: '' }, { score: '', weight: '' }, { score: '', weight: '' }]);
  const [result, setResult] = useState(null);

  const updateGrade = (index, field, value) => {
    const newGrades = [...grades];
    newGrades[index][field] = value;
    setGrades(newGrades);
  };

  const addGrade = () => setGrades([...grades, { score: '', weight: '' }]);
  const removeGrade = (index) => grades.length > 1 && setGrades(grades.filter((_, i) => i !== index));

  const calculate = () => {
    let totalWeightedScore = 0;
    let totalWeight = 0;

    grades.forEach(g => {
      const score = parseFloat(g.score);
      const weight = parseFloat(g.weight) || 1;
      if (!isNaN(score)) {
        totalWeightedScore += score * weight;
        totalWeight += weight;
      }
    });

    if (totalWeight > 0) {
      const average = totalWeightedScore / totalWeight;
      let letterGrade = '';
      if (average >= 93) letterGrade = 'A';
      else if (average >= 90) letterGrade = 'A-';
      else if (average >= 87) letterGrade = 'B+';
      else if (average >= 83) letterGrade = 'B';
      else if (average >= 80) letterGrade = 'B-';
      else if (average >= 77) letterGrade = 'C+';
      else if (average >= 73) letterGrade = 'C';
      else if (average >= 70) letterGrade = 'C-';
      else if (average >= 67) letterGrade = 'D+';
      else if (average >= 63) letterGrade = 'D';
      else if (average >= 60) letterGrade = 'D-';
      else letterGrade = 'F';

      setResult({ average: average.toFixed(2), letterGrade });
    }
  };

  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 py-8">
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-400">Grade Calculator</span>
          </nav>
          <h1 className="text-3xl font-bold text-white mb-2">Grade Calculator</h1>
          <p className="text-gray-400 mb-8">Calculate your weighted average grade.</p>

          <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
            <div className="grid grid-cols-12 gap-3 mb-3 font-medium text-gray-400 text-sm">
              <div className="col-span-5">Score (%)</div>
              <div className="col-span-5">Weight</div>
              <div className="col-span-2"></div>
            </div>
            {grades.map((grade, index) => (
              <div key={index} className="grid grid-cols-12 gap-3 mb-3">
                <div className="col-span-5"><Input type="number" value={grade.score} onChange={(e) => updateGrade(index, 'score', e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="85" /></div>
                <div className="col-span-5"><Input type="number" value={grade.weight} onChange={(e) => updateGrade(index, 'weight', e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="1" /></div>
                <div className="col-span-2 flex items-center justify-center"><button onClick={() => removeGrade(index)} className="text-red-400 hover:text-red-300 text-xl font-bold">×</button></div>
              </div>
            ))}
            <div className="flex gap-4 mt-4">
              <Button onClick={addGrade} variant="outline" className="border-[#2a2a2a] text-gray-300">+ Add</Button>
              <Button onClick={calculate} className="bg-cyan-600 hover:bg-cyan-500 text-white">Calculate</Button>
            </div>
            {result && (
              <div className="mt-6 p-5 bg-[#0d0d0d] border border-[#2a2a2a] rounded-xl">
                <div className="grid grid-cols-2 gap-4">
                  <div className="p-4 bg-cyan-500/10 border border-cyan-500/30 rounded-lg text-center">
                    <span className="text-gray-400 text-sm">Average</span>
                    <p className="text-3xl font-bold text-cyan-400">{result.average}%</p>
                  </div>
                  <div className="p-4 bg-green-500/10 border border-green-500/30 rounded-lg text-center">
                    <span className="text-gray-400 text-sm">Letter Grade</span>
                    <p className="text-3xl font-bold text-green-400">{result.letterGrade}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default GradeCalculatorPage;
